export const packageForm = {
  data: [
    {
      title: "Structure",
      rows: [
        [
          {
            key: "code",
            type: "textField",
            label: "code",
            error: "",
            validation: "",
            mask: "",
            fill: true,
          },
        ],
        [
          {
            key: "nodeText.name",
            label: "name",
            type: "textField",
            error: "",
            validation: "",
            mask: "",
            fill: true,
          },
        ],
        [
          {
            label: "unit",
            key: "nodeText.unit",
            type: "textField",
            error: "",
            validation: "",
            mask: "",
            fill: true,
          },
        ],
      ],
    },
  ],
};
